// Import model
import { PickListCondition } from '../models/PickListCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { PickListIndexedFields } from '../models/PickListIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { PickListIndexedFieldsSerializer } from './PickListIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PickListCondition - handles JSON serialization and deserialization with type validation
 */
export class PickListConditionSerializer {
  /**
   * Deserializes a JSON string into a PickListCondition instance
   */
  static deserialize(json: string): PickListCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PickListCondition instance
   */
  static fromObject(obj: any): PickListCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PickListCondition');
    }


    const instance: PickListCondition = {
      fieldName: obj['fieldName'] as PickListIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PickListCondition instances
   */
  static deserializeArray(json: string): PickListCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PickListCondition instance to a JSON string
   */
  static serialize(instance: PickListCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PickListCondition instance to a plain object
   */
  static toObject(instance: PickListCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of PickListCondition instances to a JSON string
   */
  static serializeArray(instances: PickListCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
